import { axios } from "@/client/libs/axios";
import { AxiosResponse } from "axios";
import { BonusDto, FilterBonusRefType } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import qs from "qs";

export const fetchBonus = async (page: number, filter?: FilterBonusRefType | null) => {
  if (filter) {
    const response = await axios.get<
      { page: number; data: BonusDto[] },
      AxiosResponse<{ page: number; data: BonusDto[] }>
    >("/bonus", {
      params: {
        page: page,
        ...filter,
      },
      paramsSerializer: (params) => qs.stringify(params),
    });
    console.log(response);
    return response.data;
  }

  const response = await axios.get<
    { page: number; data: BonusDto[] },
    AxiosResponse<{ page: number; data: BonusDto[] }>
  >("/bonus", {
    params: { page: page },
  });
  console.log(response);
  return response.data;
};

export const useBonus = (page: number, filter?: FilterBonusRefType | null) => {
  const { data: bonus, error } = useQuery({
    queryKey: ["bonus", filter, page],
    queryFn: () => fetchBonus(page, filter),
  });

  return { bonus, error };
};
